import { cssVars } from '@/app/styles';
import { Tooltip } from 'rsuite';
import styled from 'styled-components';

export const Wrapper = styled.div`
  width: ${cssVars.width.verticalNav};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: rgba(221, 232, 255, 0.5);
  box-shadow: 0 1px 10px 0 rgba(177, 184, 193, 0.3);
  z-index: 2;
  mix-blend-mode: multiply;
`;

export const TopHalf = styled.div`
  flex-grow: 1;
  gap: 40px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

export const StyledRentalscapeLogo = styled.div.attrs({
  className: 'rn-badge',
})`
  position: relative; // This ensures the badge is positioned relative to this div
  margin-top: ${cssVars.dashboardMarginTop};
  margin-bottom: ${cssVars.verticalNavItemMarginBottom};
  width: 28px;

  svg {
    width: 100%; // This ensures the SVG takes the full width of the div
    height: auto;
  }
`;

export const VerticalNav = styled.div`
  gap: 24px;
  width: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const BottomHalf = styled.div`
  gap: 24px;
  flex-grow: 2;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
`;

export const CustomCityNameTooltip = styled(Tooltip)`
  .rs-tooltip-arrow {
    display: none;
  }

  .rs-tooltip-inner {
    background-color: #101938;
    opacity: 0.8;
    height: 28px;
    display: flex;
    align-items: center;
  }
`;
